export default __webpack_public_path__ + "static/116-min-min-15587e14649e8aea197c787b0344bb8e.jpg";